/* Точечные исправления доступности, которые нельзя сделать в Liquid,
   потому что разметку создают сторонние скрипты (slick, PhotoSwipe,
   Judge.me, app-блок корзины Opus).

   1. aria-hidden + фокусируемые потомки.
      Слайдеры помечают неактивные слайды aria-hidden="true", но ссылки и
      кнопки внутри остаются в порядке табуляции. Скринридер их не видит,
      а клавиатура попадает — это ошибка aria-hidden-focus у Lighthouse.
      Держим tabindex="-1" у всего фокусируемого внутри скрытых контейнеров
      и возвращаем исходное значение, когда контейнер снова показан.

   2. Кнопки без доступного имени.
      Кнопка покупки в app-блоке корзины Opus и кнопки выбора формы в
      калькуляторе, вставленном custom-liquid блоком прямо в JSON-шаблон
      товара, содержат только иконку. Проставляем им aria-label.

   Область действия намеренно ограничена конкретными селекторами: глобально
   вмешиваться в tabindex небезопасно. */
(function () {
  'use strict';

  var SCOPE = '.slick-slide, .pswp, .fc-clone, .product-main-slide';
  var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, [tabindex]';
  var SAVED = 'data-a11y-prev-tabindex';

  var script =
    document.currentScript ||
    document.querySelector('script[src*="a11y-fixes"]');
  function label(attr, fallback) {
    return (script && script.getAttribute(attr)) || fallback;
  }
  var addToCartLabel = label('data-label-add-to-cart', 'Add to cart');
  var shapeLabels = {
    square: label('data-label-shape-square', 'Square shape'),
    cylinder: label('data-label-shape-cylinder', 'Cylinder shape')
  };

  function isFocusable(el) {
    if (el.disabled) return false;
    var ti = el.getAttribute('tabindex');
    if (ti !== null) return parseInt(ti, 10) >= 0;
    return true;
  }

  function hide(el) {
    if (!isFocusable(el)) return;
    if (!el.hasAttribute(SAVED)) {
      el.setAttribute(SAVED, el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
    }
    el.setAttribute('tabindex', '-1');
  }

  function restore(el) {
    if (!el.hasAttribute(SAVED)) return;
    var prev = el.getAttribute(SAVED);
    if (prev === '') {
      el.removeAttribute('tabindex');
    } else {
      el.setAttribute('tabindex', prev);
    }
    el.removeAttribute(SAVED);
  }

  function syncAriaHidden() {
    var containers = document.querySelectorAll(SCOPE);
    for (var i = 0; i < containers.length; i++) {
      var c = containers[i];
      var hidden = c.getAttribute('aria-hidden') === 'true';
      var list = c.querySelectorAll(FOCUSABLE);
      for (var j = 0; j < list.length; j++) {
        if (hidden) hide(list[j]);
        else restore(list[j]);
      }
      /* Сам контейнер тоже может быть фокусируемым. */
      if (c.matches(FOCUSABLE)) {
        if (hidden) hide(c);
        else restore(c);
      }
    }
  }

  function setLabel(el, text) {
    if (!el || el.hasAttribute('aria-label') || el.textContent.trim()) return;
    el.setAttribute('aria-label', text);
  }

  function labelButtons() {
    var buy = document.querySelectorAll('button.cd-buy-button:not([aria-label])');
    for (var i = 0; i < buy.length; i++) setLabel(buy[i], addToCartLabel);

    var shapes = document.querySelectorAll('.shape-tab[data-shape]:not([aria-label])');
    for (var j = 0; j < shapes.length; j++) {
      var key = shapes[j].getAttribute('data-shape');
      if (shapeLabels[key]) setLabel(shapes[j], shapeLabels[key]);
    }
  }

  /* Наблюдатель ловит любую перестройку слайдеров, поэтому запуск
     откладываем: одна проверка на 200 мс вместо одной на каждую мутацию. */
  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      syncAriaHidden();
      labelButtons();
    }, 200);
  }

  function init() {
    syncAriaHidden();
    labelButtons();

    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });

    /* Слайдеры темы перестраиваются на этих событиях. */
    ['shopify:section:load', 'collection:reloaded'].forEach(function (evt) {
      document.addEventListener(evt, schedule);
    });
    window.addEventListener('resize', schedule, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
